import React, { memo, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { CheckIcon, EllipsisIcon, CheckUserIcon, DisableUserIcon } from '~svg';
import { Tooltip } from '../../../../component';
import './employeeCard.scss';

const EmployeeCard = ({ ...rest }) => {
  const {
    customClass = '',
    displayName,
    detail,
    boxValue,
    roleName,
    avatar = '',
    language: { direction, name },
    buttonList,
    handleAction,
    handleCardClick = () => null,
    id = '',
    positions,
    isActive = false,
  } = rest;

  const [alert, setAlert] = useState(null);
  const [showCollapse, setShowCollapse] = useState(false);
  const [queryId, setQueryId] = useState('#dropdown-menu');

  const copying = () => {
    navigator.clipboard.writeText(boxValue);
    setAlert(true);
    window.setTimeout(() => {
      setAlert(false);
    }, 1500);
  };

  useEffect(() => {
    const elements = document.querySelectorAll('[id*="dropdown-menu"]');
    const specificElement = document.querySelector(queryId);
    if (specificElement?.classList.contains('show')) {
      specificElement.classList.remove('show');
    } else {
      if (elements.length) {
        elements.forEach((element) => {
          element.classList.remove('show');
        });
      }
      if (specificElement) {
        specificElement.classList.add('show');
      }
    }
  }, [showCollapse]);

  return (
    <>
      <div className={`card-height ${customClass}`}>
        <div
          onClick={() => handleCardClick(id)}
          className={`col-md-11 col-12 employee-card d-flex flex-column 
      justify-content-between bg-white default-border-radius-small border
      default-border-radius p-xl-4 p-3 shadow `}
        >
          <div className="employee-card-header d-flex align-items-center justify-content-between flex-wrap pb-3">
            <figure className="col-xxl-2 col-md-3 col-sm-2 col-3 px-0 m-0">
              <img
                src={require(`../../../../content/images/avatars/${
                  avatar || '10.png'
                }`)}
                alt="avatar"
                className="img-fluid img-responsive"
              />
            </figure>
            <div className="d-flex flex-wrap flex-row justify-content-end col-9 px-0 ">
              {roleName?.map((item, itemIndex) => {
                return (
                  itemIndex < 2 && (
                    <div
                      className={`col-5 px-0 mx-${itemIndex !== 0 ? '1' : '0'}`}
                      key={`role-${itemIndex}`}
                    >
                      <span
                        className={`bg-secondary-light px-1 py-1 default-border-radius-small text-nowrap text-truncate ${
                          direction === 'rtl'
                            ? 'font-xl-small font-sm-msmall font-xs-smaller font-msmall'
                            : 'font-xl-msmall font-lg-smaller font-md-xsmall font-sm-msmall font-xs-smaller font-msmall'
                        } tag-box text-white  ${
                          item.name.en == 'admin' && 'admin-tag'
                        } `}
                      >
                        <div className="w-100 text-nowrap text-truncate">
                          <div className="text-center text-nowrap text-truncate">
                            {item?.name?.[name === 'fa' ? 'fa' : 'en'] || '---'}
                          </div>
                        </div>
                      </span>
                    </div>
                  )
                );
              })}
            </div>
          </div>
          <div className="employee-card-body font-small  pb-2">
            <div className="d-flex flex-row justify-content-between align-items-center font-lg-normal font-md-small font-sm-normal font-xs-normal font-small text-third m-0 font-weight-bold text-nowrap">
              <Tooltip
                position={'bottom'}
                content={displayName || ''}
                direction={direction}
                backgroundColor="warning"
                textColor="dark"
                customClassName="col-10 px-0 text-start"
              >
                <div className="w-100 d-flex px-0">
                  <span className="w-100 text-nowrap text-truncate px-2">
                    {displayName || '---'}
                  </span>
                </div>
              </Tooltip>
              <div className="col-2 d-flex justify-content-end px-0">
                {isActive ? (
                  <CheckUserIcon size={20} color="#3d4a8f" />
                ) : (
                  <DisableUserIcon size={20} color="red" />
                )}
              </div>
            </div>
            <div className="text-primary py-3 text-start font-msmall text-nowrap px-2 font-weight-bold w-100 text-truncate">
              {detail || '--'}
            </div>
            <Tooltip
              position={'top'}
              content={boxValue || ''}
              direction={boxValue.includes('+') ? 'ltr' : direction}
              backgroundColor="warning"
              textColor="dark"
              customClassName="w-100"
            >
              <div
                className={`email-box font-weight-bold d-flex-align-items-center justify-content-start bg-gray px-3 py-2 text-dark d-flex align-items-center justify-content-between default-border-radius-small`}
                style={{ height: '2.1rem', direction: 'ltr' }}
                onClick={copying}
                key={`${boxValue}`}
              >
                <span
                  className={`font-msmall text-third d-flex ${
                    direction === 'rtl'
                      ? 'flex-row'
                      : 'flex-row-reverse justify-content-end'
                  } align-items-center text-nowrap text-truncate`}
                >
                  <span className="text-nowrap text-truncate">
                    {boxValue || '---'}
                  </span>
                </span>
                <span className="px-1">
                  <CheckIcon size={14} color="#00c853" />
                </span>
              </div>
            </Tooltip>
            {alert && (
              <>
                <div className="w-100 d-flex flex-row justify-content-end">
                  <div
                    className="bg-secondary-light text-white alert alert-success position-absolute default-border-radius-small px-3 py-1 mt-1 font-lg-msmall font-md-smaller font-sm-msmall font-smaller"
                    role="alert"
                  >
                    <FormattedMessage id="profile.copy" />
                  </div>
                </div>
              </>
            )}
            <div className="w-100 d-flex flex-row justify-content-start align-items-center">
              <p className="font-msmall py-4 mt-2 mb-0 px-2 text-third">
                <span className="text-third">
                  <FormattedMessage id="profile.status" />
                </span>
                <span className="px-1">:</span>
                <span className="text-dark">
                  <FormattedMessage id="profile.presensnt" />
                </span>
              </p>
            </div>
          </div>
          <div
            className="employee-card-footer d-flex align-items-center font-small d-flex justify-content-between "
            style={{ height: '27px' }}
          >
            {buttonList.map((item, itmIndx) => {
              switch (item.type) {
                case 'popover':
                  return (
                    <div
                      key={`popover-card-${itmIndx}`}
                      className="dropdown col-4 px-0 d-flex align-items-center justify-content-center h-100 bg-gray default-border-radius-small py-1"
                    >
                      <Tooltip
                        position={'top'}
                        content={item.data}
                        direction={'ltr'}
                        backgroundColor="warning"
                        textColor="dark"
                      >
                        <a
                          href={`tel:${item.data}`}
                          className={`d-flex justify-content-center align-items-center col-11 px-0 text-center text-decoration-none ${
                            direction === 'rtl'
                              ? 'font-sm-msmall'
                              : 'font-xxl-smaller font-md-tiny font-sm-smaller'
                          } font-xs-smaller font-msmall border-0 text-dark`}
                          onClick={() => {
                            navigator.clipboard.writeText(item.data);
                          }}
                        >
                          {<FormattedMessage id={item.displayName} />}
                        </a>
                      </Tooltip>
                    </div>
                  );
                case 'dropdown':
                  return (
                    <div
                      key={`dropdown-card-${itmIndx}`}
                      className="dropdown col-4 px-0 d-flex justify-content-center h-100"
                    >
                      <button
                        name={`more-choose-${itmIndx}`}
                        id={`more-choose-${itmIndx}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowCollapse(!showCollapse);
                          setQueryId(`#dropdown-menu-${id}`);
                        }}
                        data-toggle="collapse"
                        data-target="#dropdown-card"
                        aria-expanded="true"
                        aria-controls="dropdown-card"
                        className="col-11 px-0 bg-gray default-border-radius-small d-flex flex-column align-items-center justify-content-center border-0"
                      >
                        <EllipsisIcon size={21} />
                      </button>
                      <div
                        id="dropdown-card"
                        className="d-flex justify-content-end align-items-center position-absolute w-100 top-position"
                      >
                        <ul
                          id={`dropdown-menu-${id}`}
                          className={`dropdown-menu position-static bg-gray text-dark card-submenu popup-menu shadow py-0 default-border-radius my-2 font-weight-bold  font-small dropdown-menu-${direction} ${positions}`}
                        >
                          {item.data.map((submenu, submenuIndx) => (
                            <li
                              onClick={() => {
                                setShowCollapse(false);
                                handleAction(submenu.name);
                              }}
                              key={`button-submneu-${submenuIndx}`}
                              className={`dropdown-link text-start cursor-pointer	 py-3 px-4 font-md-msmall font-sm-msmall font-xs-xsmall font-msmall
                        ${submenuIndx == 0 && 'default-border-top-radius-small'}
                        ${
                          submenuIndx == item.data.length - 1 &&
                          'default-border-bottom-radius-small'
                        }`}
                            >
                              <FormattedMessage id={submenu.displayName} />
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  );
                default:
                  return (
                    <div
                      className="dropdown  text-decoration-none col-4 px-0 d-flex flex-row justify-content-center h-100"
                      key={`button-card-${itmIndx}`}
                    >
                      {item.name === 'message' ? (
                        <a
                          href={`mailto:/${item.data}`}
                          onClick={() => handleAction(item.name)}
                          className={`bg-gray default-border-radius-small text-center text-decoration-none ${
                            direction === 'rtl'
                              ? 'font-sm-msmall'
                              : 'font-xxl-smaller font-md-tiny font-sm-smaller'
                          } font-xs-smaller font-msmall py-1 col-11 px-0 border-0 text-dark`}
                        >
                          {<FormattedMessage id={item.displayName} />}
                        </a>
                      ) : (
                        <div
                          onClick={() => handleAction(item.name)}
                          className={`d-flex justify-content-center align-items-center bg-gray default-border-radius-small text-center cursor-pointer ${
                            direction === 'rtl'
                              ? 'font-sm-msmall'
                              : 'font-xxl-smaller font-md-tiny font-sm-smaller'
                          } font-xs-smaller font-msmall py-1 col-11 px-0 border-0 text-dark`}
                        >
                          <FormattedMessage id={item.displayName} />
                        </div>
                      )}
                    </div>
                  );
              }
            })}
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(memo(EmployeeCard));
